// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__db44I","box":"CardDetails_box__+lFde","icon":"CardDetails_icon__wINiF","icon_text_container":"CardDetails_icon_text_container__velrt"};